// Auto-generated by typewriter from C# model
export enum CentralAdminEntityType {
    Region = 0,
    Forest = 1,
    Dag = 2,
    Machine = 3,
    Location = 4,
    Rack = 5,
    CapacityUnit = 6,
    PartitionUnit = 7,
    LoadBalancer = 8,
    SubRegion = 9,
    Vip = 10,
    Tenant = 11,
    TenantId = 12,
    FaultZone = 13
}
